import { finalize, tap } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { Router } from '@angular/router';
import { ToastService } from '../core/services/toast/toast.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private loaderService: LoaderService,
        private toast: ToastService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        let ok: string;

        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        const clonedReq = req.clone({ headers });
        return next.handle(clonedReq)
            .pipe(
                tap(
                    event => { ok = event instanceof HttpResponse ? 'succeeded' : ''; },
                    error => { ok = error, this.onSubscribeError(ok); }
                    // Log when response observable either completes or errors
                ),
                finalize(() => {
                    this.loaderService.hide();
                })
            );
    }

    private onSubscribeError(error: any) {
        if (error.status === 401) {
            this.router.navigate(['/error/401']);
            return false;
        } else {
            const message = error.error.message;
            this.toast.danger(message, 'Error!');
        }
    }
}
